import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    overflowX: 'scroll',
    selectors: {
      '& .ms-DetailsHeader': {
        backgroundColor: theme.palette.neutralWhite,
        paddingTop: 0,
        borderBottom: `1px solid ${theme.palette.themePrimary}`,
      },
      '& .ms-DetailsHeader .ms-DetailsHeader-cellTitle': {
        color: theme.palette.neutralDark,
        height: '100%',
        alignItems: 'center',
        fontSize: pxToRem(14),
        fontWeight: 600,
        paddingLeft: '0',
        paddingRight: '0',
      },
      '& .ms-List-cell': {
        backgroundColor: theme.palette.neutralWhite,
        minHeight: 'auto',
      },
      [layout.breakpoints.min.md]: {
        overflowX: 'auto',
      },
    },
  },
  row: {
    backgroundColor: theme.palette.neutralWhite,
    minHeight: 'auto',
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    cursor: 'pointer',
    selectors: {
      '& .ms-DetailsRow-cell': {
        minHeight: 'auto',
        maxHeight: '2rem',
        padding: '.5rem 0',
        color: theme.palette.neutralSecondary,
      },
      '& .ms-DetailsRow-cell[data-automation-key="name"], & .ms-DetailsRow-cell[data-automation-key="title"]':
        {
          color: theme.palette.neutralDark,
          fontSize: pxToRem(14),
        },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  iconColumn: {
    height: pxToRem(14),
    width: pxToRem(34),
    textAlign: 'center',
    fontSize: pxToRem(14),
    color: theme.palette.themePrimary,
  },
});
